module.exports = __webpack_public_path__ + "static/media/museum_diorama_mural_concept_2008.ac038cc0.webp";